import { ReactionType, VoteType } from "components/server-types";
import { useKeyPress } from "mds/hooks/use-key-press";
import { useAppSelector } from "store/index";
import { selectCurrentClassUserIsInPersonClass } from "store/selectors";
import { useAv } from "utils/av";
import { useClassActions } from "utils/class-utils";

const POSSIBLE_KEYS = [
  // SIGNALS
  "y",
  "n",
  "h",
];

const POSSIBLE_ALT_KEYS = [];

const POSSIBLE_SHIFT_KEYS = [
  // REACTIONS
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
];

const REACTION_KEYS_MAP: Record<string, ReactionType> = {
  "1": "like",
  "2": "dislike",
  "3": "agree",
  "4": "disagree",
  "5": "laugh",
  "6": "wow",
  "7": "love",
  "8": "clap",
};

const VOTE_KEYS_MAP: Record<string, VoteType> = {
  y: "yes",
  n: "no",
};

export const KeyboardShortcutsController = () => {
  const isInInPersonClass = useAppSelector(selectCurrentClassUserIsInPersonClass);
  const { isInVirtualClass, toggleHand } = useAv();
  const { toggleReaction, toggleVote } = useClassActions();

  useKeyPress(
    POSSIBLE_KEYS,
    POSSIBLE_ALT_KEYS,
    POSSIBLE_SHIFT_KEYS,
    (key) => {
      if (!isInInPersonClass && !isInVirtualClass) {
        return;
      }

      if (Object.keys(VOTE_KEYS_MAP).includes(key)) {
        toggleVote(VOTE_KEYS_MAP[key]);
      } else if (key === "h" && isInVirtualClass) {
        toggleHand();
      }
    },
    () => {},
    (key) => {
      if (!isInInPersonClass && !isInVirtualClass) {
        return;
      }

      if (Object.keys(REACTION_KEYS_MAP).includes(key)) {
        toggleReaction(REACTION_KEYS_MAP[key]);
      }
    },
  );

  return null;
};
